import React, { useState } from 'react';

export default function Account() {
  // Dummy user data
  const user = {
    name: 'John Doe',
    email: 'john.doe@example.com',
    mobile: '+91 9876543210',
    gender: 'Male',
  };

  const [form, setForm] = useState({
    current: '',
    new: '',
    confirm: '',
  });
  const [msg, setMsg] = useState('');

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!form.current || !form.new || !form.confirm) {
      setMsg('Please fill all fields.');
      return;
    }
    if (form.new !== form.confirm) {
      setMsg('New passwords do not match.');
      return;
    }
    setMsg('Password reset successful! (dummy)');
    setForm({ current: '', new: '', confirm: '' });
  };

  return (
    <div style={{ maxWidth: 480, margin: '40px auto', background: '#fff', borderRadius: 12, boxShadow: '0 2px 12px #0001', padding: 32 }}>
      <h2 style={{ marginBottom: 24 }}>My Account</h2>
      <div style={{ marginBottom: 24 }}>
        <div><b>Name:</b> {user.name}</div>
        <div><b>Email:</b> {user.email}</div>
        <div><b>Mobile:</b> {user.mobile}</div>
        <div><b>Gender:</b> {user.gender}</div>
      </div>
      <hr style={{ margin: '32px 0' }} />
      <h3 style={{ marginBottom: 16 }}>Reset Password</h3>
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: 16 }}>
          <label>Current Password</label>
          <input
            type="password"
            name="current"
            value={form.current}
            onChange={handleChange}
            style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }}
            autoComplete="current-password"
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>New Password</label>
          <input
            type="password"
            name="new"
            value={form.new}
            onChange={handleChange}
            style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }}
            autoComplete="new-password"
          />
        </div>
        <div style={{ marginBottom: 16 }}>
          <label>Confirm New Password</label>
          <input
            type="password"
            name="confirm"
            value={form.confirm}
            onChange={handleChange}
            style={{ width: '100%', padding: 8, borderRadius: 6, border: '1px solid #ccc', marginTop: 4 }}
            autoComplete="new-password"
          />
        </div>
        <button type="submit" style={{ background: '#6366f1', color: '#fff', border: 'none', borderRadius: 6, padding: '10px 24px', fontWeight: 600, fontSize: 16, cursor: 'pointer' }}>Reset Password</button>
      </form>
      {msg && <div style={{ marginTop: 18, color: msg.includes('successful') ? '#059669' : 'red', fontWeight: 500 }}>{msg}</div>}
    </div>
  );
} 